module.exports = {
  billing_reconciliation: '对账',
  billing_bill: '账单',
  billing_accountStatement: '对账单',
  billing_cancel: '取消',
  billing_return: '返回',
  billing_save: '保存',
  billing_edit: '编辑',
  billing_collectInvoice: '收票',
  billing_drawInvoice: '开票',
  billing_writeOff: '销账',
  billing_applyForPayment: '申请付款',
  billing_paymentBillState: '付款单状态',
  billing_print: '打印',
  billing_adjustBillDate: '调整账单日期',
  billing_addCharges: '加入费用',
  billing_deleteCharges: '移除费用',
  billing_deleteAll: '移除全部',
  billing_viewDeleteChargeDetail: '查看/移除明细',
  billing_newAdjustment: '增加调整',
  billing_editAdjustment: '修改调整',
  billing_deleteAdjustment: '删除调整',
  billing_diffCharge: '处理差额',
  billing_cancelConfirm: '取消确认',
  billing_batchConfirm: '批量确认',
  billing_reconciliationAmount: '对账金额',
  billing_exchangeRate: '汇率',
  // billing_bill: '账单',
  billing_charges: '费用',
  billing_business: '业务',
  billing_recheck: '复核',
  billing_cancelRecheck: '取消复核',
  billing_recheckTip: '复核账单前请先确认账单',
  billing_recheckStatus: '账单复核状态',
  billing_reviewPeople: '账单复核人',
  billing_reviewDate: '账单复核时间',
  billingView_Determine: '确定',
  billingView_Close: '关闭',

  chargeList_query: '查询',
  chargeList_newBill: '新建账单',
  chargeList_startReconciliation: '开始对账',
  chargeList_drawCollectInvoice: '开票/收票',
  chargeList_writeOff: '销账',
  chargeList_applyForPayment: '申请付款',
  chargeList_submission: '提交',
  chargeList_cancelSubmit: '取消提交',
  chargeList_revenueAndExpenditureMethod: '收付方式',
  chargeList_invoiceRevenueAndExpenditureMethod: '发票收付类型',
  chargeList_receivables: '应收',
  chargeList_payables: '应付',
  chargeList_all: '全部',
  chargeList_feeType: '费用类型',
  chargeList_domestic: '国内',
  chargeList_international: '国外',
  chargeList_reconciliationType: '对账类型',
  chargeList_accordingToCharges: '按费用',
  chargeList_accordingToBusiness: '按业务',
  chargeList_cancelReconciliation: '取消对账',
  chargeList_saveReconciliation: '保存对账',
  chargeList_newAdjustment: '增加调整',
  chargeList_editAdjustment: '修改调整',
  chargeList_deleteAdjustment: '删除调整',
  chargeList_diffCharge: '处理差额',
  chargeList_cancelConfirm: '取消确认',
  chargeList_batchConfirm: '批量确认',

  billingCharge_businessNumber: '业务编号',
  billingCharge_consignationCompany: '委托单位',
  billingCharge_settlementCompany: '结算单位',
  billingCharge_mblNo: '主单号',
  billingCharge_vessel: '船名',
  billingCharge_voyage: '航次',
  billingCharge_carrier: '承运人',
  billingCharge_billNo: '账单号',
  billingCharge_invoiceNo: '发票号',
  billingCharge_itemNo: '项目编号',
  billingCharge_businessType: '业务类型',
  billingCharge_businessStatus: '业务状态',
  billingCharge_solicitationType: '揽货类型',
  billingCharge_chargeItem: '费用名称',
  billingCharge_feeStatus: '费用状态',
  billingCharge_confirmStatus: '确认状态',
  billingCharge_businessDate: '业务日期',
  billingCharge_amountRange: '金额区间',
  billingCharge_receivablesInvoicingDate: '应收开票日期',
  billingCharge_currency: '币种',
  billingCharge_operation: '操作',
  billingCharge_sales: '销售',
  billingCharge_advanceMoneyForAnotherOrNot: '是否代垫',
  billingCharge_adjustedOrNot: '是否调整',
  billingCharge_wroteOffOrNot: '是否已核销',
  billingCharge_generatedBillsOrNot: '是否已生成账单',
  billingCharge_invoicedOrNot: '是否已开票',
  billingCharge_appliedForPaymentOrNot: '是否已申请付款',
  billingCharge_drawABbillOrNot: '是否需要开票',
  billingCharge_department: '部门',
  billingCharge_contactPerson: '联系人',
  billingCharge_settlementType: '结算类型',
  billingCharge_invoicingMethod: '开票方式',
  billingCharge_accrued: '已计提',
  billingCharge_receivablesInvoicingStatus: '应收开票状态',
  billingCharge_bookingNo: '订舱编号',
  billingCharge_unitPrice: '单价',
  billingCharge_invoiceHeader: '发票抬头',
  billingCharge_businessReferenceNumber: '业务参考号',
  billingCharge_warehouseNo: '进仓编号',
  billingCharge_vesselAndVoyage: '船名航次',
  billingCharge_portOfLoading: '起运港',
  billingCharge_portOfTransfer: '中转港',
  billingCharge_portOfDestination: '目的港',
  billingCharge_portOfLoadingSeaport: '起运港(海港)',
  billingCharge_portOfLoadingAirport: '起运港(空港)',
  billingCharge_portOfDestinationSeaport: '目的港(海港)',
  billingCharge_portOfDestinationAirport: '目的港(空港)',
  billingCharge_portOfDischargeSeaport: '卸货港(海港)',
  billingCharge_portOfDischargeAirport: '卸货港(空港)',
  billingCharge_financialDate: '财务日期',
  billingCharge_domesticOrInternational: '国内国外',
  billingCharge_paymentType: '支付类型',
  billingCharge_amount: '数量',
  billingCharge_taxIncludedPrice: '含税价',
  billingCharge_taxExcludedPrice: '不含税价',
  billingCharge_taxAmount: '税额',
  billingCharge_theAmountOfWriteOffs: '核销金额',
  billingCharge_amountNotWrittenOff: '未销金额',
  billingCharge_reconciliationAmount: '对账金额',
  billingCharge_difference: '差额',
  billingCharge_confirmationRemarks: '确认备注',
  billingCharge_confirmState: '是否确认',
  billingCharge_creator: '创建人',
  billingCharge_dateCreated: '创建日期',
  billingCharge_remarks: '备注',

  billingJob_businessNumber: '业务编号',
  billingJob_consignationCompany: '委托单位',
  billingJob_settlementCompany: '结算单位',
  billingJob_mblNo: '主单号',
  billingJob_vessel: '船名',
  billingJob_voyage: '航次',
  billingJob_carrier: '承运人',
  billingJob_billNo: '账单号',
  billingJob_invoiceNo: '发票号',
  billingJob_itemNo: '项目编号',
  billingJob_businessType: '业务类型',
  billingJob_soNo: 'SO NO',
  billingJob_businessStatus: '业务状态',
  billingJob_solicitationType: '揽货类型',
  billingJob_chargeItem: '费用名称',
  billingJob_feeStatus: '费用状态',
  billingJob_confirmStatus: '确认状态',
  billingJob_businessDate: '业务日期',
  billingJob_amountRange: '金额区间',
  billingJob_receivablesInvoicingDate: '应收开票日期',
  billingJob_currency: '币种',
  billingJob_operation: '操作',
  billingJob_sales: '销售',
  billingJob_advanceMoneyForAnotherOrNot: '是否代垫',
  billingJob_adjustedOrNot: '是否调整',
  billingJob_wroteOffOrNot: '是否已核销',
  billingJob_generatedBillsOrNot: '是否已生成账单',
  billingJob_invoicedOrNot: '是否已开票',
  billingJob_appliedForPaymentOrNot: '是否已申请付款',
  billingJob_drawABbillOrNot: '是否需要开票',
  billingJob_department: '部门',
  billingJob_contactPerson: '联系人',
  billingJob_settlementType: '结算类型',
  billingJob_invoicingMethod: '开票方式',
  billingJob_accrued: '已计提',
  billingJob_receivablesInvoicingStatus: '应收开票状态',
  billingJob_bookingNo: '订舱编号',
  billingJob_unitPrice: '单价',
  billingJob_invoiceHeader: '发票抬头',
  billingJob_businessReferenceNumber: '业务参考号',
  billingJob_warehouseNo: '进仓编号',
  billingJob_vesselAndVoyage: '船名航次',
  billingJob_portOfLoading: '起运港',
  billingJob_portOfTransfer: '中转港',
  billingJob_portOfDestination: '目的港',
  billingJob_portOfLoadingSeaport: '起运港(海港)',
  billingJob_portOfLoadingAirport: '起运港(空港)',
  billingJob_portOfDestinationSeaport: '目的港(海港)',
  billingJob_portOfDestinationAirport: '目的港(空港)',
  billingJob_portOfDischargeSeaport: '卸货港(海港)',
  billingJob_portOfDischargeAirport: '卸货港(空港)',
  billingJob_financialDate: '财务日期',
  billingJob_domesticOrInternational: '国内国外',
  billingJob_paymentType: '支付类型',
  billingJob_amount: '数量',
  billingJob_taxIncludedPrice: '含税价',
  billingJob_taxExcludedPrice: '不含税价',
  billingJob_taxAmount: '税额',
  billingJob_theAmountOfWriteOffs: '核销金额',
  billingJob_amountNotWrittenOff: '未销金额',
  billingJob_reconciliationAmount: '对账金额',
  billingJob_difference: '差额',
  billingJob_confirmationRemarks: '确认备注',
  billingJob_ReviewRemarks: '审核备注',
  InquiryLetterRemark: '询证函备注',
  WarmPromptAppend: '温馨提示:填写的备注会追加在原财务备注信息后面',
  WarmPromptOverwrite: '温馨提示:填写的备注会覆盖原询证函备注信息',
  billingJob_confirmState: '是否确认',
  billingJob_creator: '创建人',
  billingJob_dateCreated: '创建日期',
  billingJob_remarks: '备注',
  billingJob_customerLevel: '客户级别',
  billingJob_settlementMethod: '结算方式',
  billingJob_chargesContactPerson: '费用联系人',
  billingJob_confirmUser: '费用确认人',
  billingJob_updateUser: '费用更新人',
  // billingJob_settlementType: '结算类型',
  // billingJob_invoiceHeader: '开票抬头',
  billingJob_settleAccountsTo: '结算对象',
  billingJob_otherPartyBilling: '对方对账单号',
  billingJob_customer: '客户',
  billingJob_portOfDischarge: '卸货港',
  billingJob_dateOfDeparture: '开航日期',
  billingJob_bookingAgent: '订舱代理',
  billingJob_revenueAndExpenditureType: '收支类型',
  billingJob_chargesTotalAmount: '费用总金额',
  billingJob_dateOfArrival: '到港日期',
  billingJob_billDate: '账单日期',
  billingJob_invoiceDate: '开票日期',
  billingJob_originalCurrency: '原币种',
  billingJob_billAndCurrency: '账单币种',
  billing_billAmount: '账单金额',
  billingJob_operationDepartment: '操作部门',
  billingJob_generatedAccountStatement: '是否已生成对账单',
  billingJob_wroteOff: '是否核销',
  billingJob_aging: '账龄（天）',
  billingJob_agentBillNo: '对方账单号',
  billingJob_billStatus: '账单状态',
  billingJob_accountStatementNo: '对账单号',
  billingJob_invoicingRequirements: '开票要求',
  billingJob_proofDate: '凭证日期',
  billingJob_customerService: '客服',
  billingJob_invoicingStatus: '开票状态',
  billingJob_writeOffStatus: '核销状态',
  billingJob_writeOffStatus_bill: '账单核销状态',
  billingJob_writeOffStatus_reconciliation: '对账单核销状态',
  billingJob_amountOfMoney: '金额',
  billingJob_notInvoicedMoney: '未开票金额',
  billingJob_totalCurrency: '分币种合计',
  billingJob_totalAmountNotWrittenOff: '未销金额合计',
  billingJob_taxRate: '税率(%)',
  billingJob_customJobType: '自定义业务类型',
  billingJob_voyageLine: '航线',
  billingJob_separateNumber: '分单号',
  billingJob_dateTo: '至',
  billingJob_lockCheckBoxDate: '查询两年外数据',
  billingJob_inputDateNotEmpty: '账单日期不能为空!',
  billingJob_unlockInputDateQuery: '若选的账单日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  billingJob_billPaymentDate: '申请日期',
  billingJob_billPaymentDateNotEmpty: '申请日期不能为空!',
  billingJob_unlockBillPaymentDateQuery: '若选的申请日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  billingJob_userDefinedField1: '自定义字段1',
  billingJob_userDefinedField2: '自定义字段2',
  billingJob_userDefinedField3: '自定义字段3',
  billingJob_userDefinedField4: '自定义字段4',
  billingJob_markDate: '标记时间',
  billingJob_markUser: '标记人',
  billingJob_markStatus: '标记状态',
  billingJob_mark: '是否标记',
  billingJob_vesselAndVoyageAndFlight: '船名/航次',
  billingJob_billPaymentOrNot: '是否申请付款',
  billingJob_voyageAndFlight: '航班/航次',
  billingJob_containerDescription: '箱量描述',
  billingJob_InputDate: '对账单制单日期',

  billingView_total: '合计',
  billingView_query: '查询',
  billingView_newAccountStatement: '新建对账单',
  billingView_edit: '编辑',
  billingView_delete: '删除',
  billingView_view: '查看',
  billingView_confirm: '确认',
  billingView_cancelConfirmation: '取消确认',
  billingView_print: '打印',
  billingView_drawCollectInvoice: '开票/收票',
  billingView_writeOff: '销账',
  billingView_applyForPayment: '申请付款',
  billingView_revenueAndExpenditureMethod: '收付方式',
  billingView_receivables: '应收',
  billingView_payables: '应付',
  billingView_all: '全部',
  billingView_billType: '账单类型',
  billingView_domestic: '国内',
  billingView_international: '国外',
  billingView_reconciliationType: '对账类型',
  billingView_accordingToBusiness: '按业务',
  billingView_accordingToCharges: '按费用',

  billingForm_taxAmount: '含税金额',
  billingForm_taxFreeAmount: '不含税金额',
  billingForm_bankOfDeposit: '开户银行',
  billingForm_bankAccount: '银行账号',
  billingForm_collectAndPrepaidOrNot: '是否代收垫付',
  billingForm_unit: '单位',

  billingAccount_accountStatementType: '对账单类型',
  billingAccount_writeOffOrNot: '是否已销账',
  billingAccount_invoicingInformation: '开票信息',

  billingGroup_dateOfFiling: '制单日期',
  billingGroup_settleAccountsTo: '结算对象',
  billingGroup_invoicingAddress: '开票地址',
  billingGroup_addBill: ' 加入账单',
  billingGroup_deleteBill: '移除账单',
  billingGroup_previous: '上一个',
  billingGroup_next: '下一个',
  billingJob_settlementAgent: '结算代理',
  billingJob_billingCreator: '账单创建人',

  Query: '查询',
  View: '查看',
  Add: '新增',
  Edit: '编辑',
  Delete: '删除',
  print: '打印',
  statistics: '统计',
  ExportAllExcel: '全部导出Excel',
  BusinessNo: '业务编号',
  WarehouseNo: '进仓编号',
  WayBillNumber: '运单号',
  Destination: '目的站',
  PortOfDestination: '目的港',
  WarehouseEntryTime: '入库时间',
  DeliveryTime: '出库时间',
  InputTime: '录入时间',
  DataEntryClerk: '录入人',
  NumberOfCases: '件数',
  Weight: '重量',
  Volume: '体积',
  ComputationIsAffectedByDampness: '破损受潮',
  IntoTheWarehousePhotos: '进仓照片',
  WarehouseName: '仓库名称',
  Warehouseman: '仓库员',
  StorageLocation: '库位',
  Receiptnumber: '回执编号',
  BlNo: '提单号',
  UploadFile: '上传文件',
  batchdownload: '批量下载',
  ResetFilter: '重置条件',
  billingCharge_billingGroupNo: '对账单号',
  modifiedBy: '修改人',
  dateModified: '修改日期',
  includeAdjustmentCharge: '是否包含调整费用',
  invoiceHeader: '开票抬头',
  revenueOrExpenditure: '收支',
  InvoicingAmount: '开票金额',
  invoicingExchangeRate: '开票汇率',
  invoiceInformation: '发票信息',
  LoadingPort: '装货港',
  seaportOfDischarge: '卸货港（海港）',
  billingJob_confirmDate: '账单确认时间',
  billingJob_theAmountOfNotWriteOffs: '未核销金额',
  QueryAgencyShareBill: '查询代理分成账单',
  ForceDeleteBilling: '{0}账单{1}，不能强制删除。',
  HasBillPayment: '已付款申请',
  HasBillingGroup: '已创建对账单',
  HasWriteOff: '已核销',
  HasClosingAccount: '已关账',
  OppositeBillNoAlreadyExists: '<strong>对方账单号</strong> 已存在，是否继续？',
  DueDate: '费用到期日',
  DueDateDirty: '到期日计算状态',
  InCalculation: '计算中',
  NotCalculated: '不计算',
  Calculated: '已计算',
  CancelConfirmedBillSameTime: '是否同时取消确认账单？',
  BillingConfirmStatus: '账单确认状态',
  ApplyForInvoicing: '申请开票',
  BillSettlementType: '账单结算类型',
  CostCannotExceed3Currencies: '费用不能超过3个币种',
  DomesticBill: '国内账单',
  Currency: '币种',
  CannotRemoveAllFees: '不能移除全部费用！',
  InvalidDate: '作废日期',
  Bill: '账单:',
  Billing_Requirements: '账单开票要求',
  ForeignInvoiceTime: '国外发票开票时间'
}
